import { render } from "./VehicleRegister.vue?vue&type=template&id=78935c68"
import script from "./VehicleRegister.vue?vue&type=script&lang=js"
export * from "./VehicleRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__